
import React from 'react';
import FusionCharts from 'fusioncharts/core';
import Cylinder from 'fusioncharts/viz/cylinder';

FusionCharts.addDep(Cylinder);

class CylinderPromo extends React.Component
{
    constructor(props) {
        super(props);
        this.state = {
            promo: {}
        };
    }

    componentWillMount()
    {
        let self = this;
        let promo = self.props.promo;

        self.setState({
            promo: promo
        });
    }

    componentDidMount()
    {
        let self = this;
        let color = "";

        switch (self.state.promo.name) {
            case "Amazon": color = "#3D00BE"; break;
            case "Cine": color = "#E5C225"; break;
            case "Cine VIP": color = "#CF0000"; break;
            case "iTunes": color = "#F54687"; break;
            case "Spotify": color = "#00EC66"; break;
            case "Starbucks": color = "#006D3E"; break;
            case "Tiempo Aire": color = "#6DB3BF"; break;
            case "Vips": color = "#FF0000"; break;
        }

        let chartInstance = new FusionCharts({
            type: 'cylinder',
            width: '100%',
            height: '300', // Height of the chart
            dataFormat: 'json', // Data type
            renderAt: self.state.promo.name, //container where the chart will render
            dataSource: {
                // Chart Configuration
                "chart": {
                    "theme": "zune",
                    //"caption": self.state.promo.name,
                    "lowerLimit": "0",
                    "upperLimit": self.state.promo.max_exchangeable_codes,
                    "lowerLimitDisplay": "0",
                    "cylfillcolor": color,
                    "upperLimitDisplay": self.state.promo.max_exchangeable_codes,
                    "numberSuffix": " códigos",
                    "showValue": "1",
                    "bgColor": "#ffffff",
                    "borderThickness": "0",
                },
                // Chart Data
                "value": parseInt(self.state.promo.max_exchangeable_codes) - parseInt(self.state.promo.redeemed),
            }
        });
        // Render
        chartInstance.render();
    }

    render()
    {
        return (
            <div>
                <div id={this.state.promo.name}></div>
            </div>
        );
    }
}

export default CylinderPromo;



// WEBPACK FOOTER //
// ./resources/assets/react/dashboard/CylinderPromo.jsx